@if ({
    systemConfig: systemConfigs$ | async,
    website: website$ | async,
    partnerSitesForFooter: partnerSitesForFooter$ | async,
    websiteDisplayName: websiteDisplayName$ | async,
    customerPortalUrl: customerPortalUrl$ | async,
    currentLanguage: currentLanguage$ | async
}; as data) {
    <footer class="footer">
        <div class="footer__main">
            <div class="footer__inner">
                <div class="footer__column footer__column--brand">
                    <img class="logo" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" [alt]="data.websiteDisplayName">
                    <p class="brand__copyright">
                        © {{ data.website?.launchYear }} - {{ date | date: 'yyyy' }} {{ data.website?.displayName }} — {{ 'label.AllRightsReserved' | translate }}
                    </p>

                    <div #topGe id="top-ge" class="top-ge"></div>
                    
                    <div class="social">
                        @if (data.systemConfig?.common?.linkedInLink) {
                            <a class="social__link" [href]="data.systemConfig.common.linkedInLink" target="_blank" rel="noopener" aria-label="LinkedIn">
                                <svg-icon class="social__icon" src="assets/icons/footer-linkedin.svg"></svg-icon>
                            </a>
                        }
                        @if (data.systemConfig?.common?.facebookLink) {
                            <a class="social__link" [href]="data.systemConfig.common.facebookLink" target="_blank" rel="noopener" aria-label="Facebook">
                                <svg-icon class="social__icon" src="assets/icons/footer-facebook.svg"></svg-icon>
                            </a>
                        }
                        @if (data.systemConfig?.common?.instagramLink) {
                            <a class="social__link" [href]="data.systemConfig.common.instagramLink" target="_blank" rel="noopener" aria-label="Instagram">
                                <svg-icon class="social__icon" src="assets/icons/footer-instagram.svg"></svg-icon>
                            </a>
                        }
                        @if (data.systemConfig?.common?.xLink) {
                            <a class="social__link" [href]="data.systemConfig.common.xLink" target="_blank" rel="noopener" aria-label="X">
                                <svg-icon class="social__icon" src="assets/icons/footer-twitter.svg"></svg-icon>
                            </a>
                        }
                    </div>
                </div>

                <nav class="footer__column">
                    <p class="footer__title">{{ 'label.FooterJobseekersTitle' | translate }}</p>
                    <a class="footer__link" [routerLink]="['./jobseeker/register']">
                        {{ 'label.CvRegistration' | translate }}
                    </a>
                    <a class="footer__link" [routerLink]="['./info/', 'frequently-asked-questions-' + data.websiteDisplayName]">
                        {{ 'label.FrequentlyAskedQuestions' | translate }}
                    </a>
                    <a class="footer__link" [routerLink]="['/companies']">
                        {{ 'label.Companies' | translate }}
                    </a>
                </nav>

                <nav class="footer__column">
                    <p class="footer__title">{{ 'label.FooterCompaniesTitle' | translate }}:</p>
                    <a class="footer__link" href="{{ data.customerPortalUrl }}/customer" target="_blank" rel="noopener">
                        {{ 'label.AddAnnouncement' | translate }}
                    </a>
                    <a class="footer__link" href="{{ data.customerPortalUrl }}/customer/register" target="_blank" rel="noopener">
                        {{ 'label.CompanyRegistration' | translate }}
                    </a>
                    <a class="footer__link" [routerLink]="['./info/', 'services-' + data.websiteDisplayName]">
                        {{ 'label.ProductsAndPrices' | translate }}
                    </a>
                    <a class="footer__link" [routerLink]="['./info/', 'outsource-' + data.websiteDisplayName]">
                        {{ 'label.Outsourcing' | translate }}/{{ 'label.Outstaffing' | translate }}
                    </a>
                    <a class="footer__link" href="./assets/documents/WEB_Standard_Service_Terms_{{ data.currentLanguage }}.pdf" target="_blank" rel="noopener">
                        {{ 'label.StandardServiceTerms' | translate }}
                    </a>
                    <a class="footer__link" href="./assets/documents/WEB_Cookie_Policy.pdf" target="_blank" rel="noopener">
                        {{ 'label.CookiePolicy' | translate }}
                    </a>
                </nav>

                <nav class="footer__column">
                    <p class="footer__title">{{ 'label.FooterInformationTitle' | translate }}:</p>
                    <a class="footer__link" [routerLink]="['./info/', 'contact-us-' + data.websiteDisplayName]">
                        {{ 'label.ContactUsNow' | translate }}
                    </a>
                    <a class="footer__link" [routerLink]="['./info/', 'about-' + data.websiteDisplayName]">
                        {{ 'label.AboutOurCompany' | translate }}
                    </a>
                </nav>
            </div>
        </div>

        @if (data.partnerSitesForFooter?.length) {
            <div class="footer__partners">
                <div class="footer__inner footer__inner--partners">
                    @for (item of data.partnerSitesForFooter; track item.link) {
                        <a class="footer__link footer__link--partner" [href]="item.link" target="_blank" rel="noopener">{{ item.name }}</a>
                    }
                </div>
            </div>
        }
    </footer>
}
